import { unlocalizeRouteName } from '@marketplace/helpers/router.js'

export default ({ app, route }, inject) => {
    inject('absoluteUrl', () => {
        const localePath = app.localePath({
            name: unlocalizeRouteName(route.name),
            params: route.params,
        })

        // Combine with the base URL to make it absolute
        const baseUrl = process.env.BASE_URL || 'https://www.orderchamp.com'
        // Decode %2F back to / — Vue Router encodes slashes in catch-all route params
        return `${baseUrl}${localePath}`.replace(/%2F/gi, '/')
    })
}
